import { Box, Typography } from "@mui/material";
import React from "react";
import { colors, theme } from "../../theme/theme";
import { UploadOutlined } from "@mui/icons-material";
import { dataURItoBlob } from "../../utils/services/ImageUpload";

const ImageUploadInput = ({
  image,
  setImage,
  width,
  height,
  label,
  labelColor,
}) => {
  return (
    <Box
      sx={{ display: "flex", flexDirection: "column", my: 2, width: "100%" }}
    >
      <Typography
        sx={{
          fontFamily: "Mulish-Regular",
          fontSize: "12px",
          color: labelColor || colors.textColor,
          fontWeight: "700",
          mb: 0.5,
          textTransform: "uppercase",
        }}
      >
        {label}
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: width || "100%",
          height: height || "150px",
          backgroundColor: "transparent",
          border: "2px dashed #ccc",
          borderRadius: "8px",
          padding: "20px",
          cursor: "pointer",
          "&:hover": {
            backgroundColor: "#f0f0f0",
            borderColor: "#aaa",
          },
          "&:active": {
            backgroundColor: "#e0e0e0",
            borderColor: theme.lightBorder,
          },
        }}
        onClick={() => {
          document.getElementById("fileInput").click();
        }}
      >
        <input
          type="file"
          id="fileInput"
          style={{ display: "none" }}
          accept={"image/*"}
          onChange={(e) => {
            dataURItoBlob(e.target.files[0], setImage);
          }}
        />

        {image ? (
          <img
            src={image}
            alt={"profile"}
            style={{
              height: "100%",
              width: "100%",
              objectFit: "contain",
              borderRadius: "14px",
            }}
          />
        ) : (
          <UploadOutlined sx={{ color: colors.primary }} />
        )}
      </Box>
    </Box>
  );
};

export default ImageUploadInput;
